module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr3-1a0d316e01204267cb439a7cdeb0ebaf.jpg";